module.exports = __webpack_public_path__ + "e8de65f954fe2ebc1ab3ebf6c0bfb7c8.svg";